import React, { useCallback } from "react";
import { useField } from "formik";
import { DirectorySort } from "@common/constants/counterparty";
import { RegisteredCounterpartyIncludeScope } from "@common/helpers/counterparties";
import { TransactionRuleActionFormSchema } from "../constants";
import { CounterpartySelect } from "../../../../counterparty/CounterpartySelect";
import { Counterparty } from "../../../../../common/types/counterparty";
import { useCounterpartiesQuery } from "../../../../../api/counterparty.api";

interface Props {
    index: number;
}

export const CounterpartyActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<
        TransactionRuleActionFormSchema["value"]
    >(`actions.${index}.value`);

    const { data: counterparties } = useCounterpartiesQuery({
        sort: DirectorySort.NAME_ASC,
        includeRegistered: RegisteredCounterpartyIncludeScope.USED,
        includeUsageStats: false,
    });

    const selectedCounterparty = counterparties?.data?.find(
        (counterparty) =>
            counterparty.counterparty.id === field.value?.counterpartyId,
    );

    const onChangeFn = useCallback(
        (counterparty: Counterparty | undefined) => {
            helpers.setValue({
                counterpartyId: counterparty?.id,
            });
        },
        [helpers],
    );

    return (
        <CounterpartySelect
            selectedCounterparty={selectedCounterparty?.counterparty}
            onChange={(counterparty) => onChangeFn(counterparty)}
            size="xs"
            dropdownKey={`counterpartyCondition${index}`}
        />
    );
};
